import { Button, ModalBody, ModalContent, ModalFooter } from '@nextui-org/react'
import { FC } from 'react'
import { getUpdate } from '../../api/tank/update'
import useHomeUpdateStore from '../../store/home/useHomeUpdateStore'
import { useSchoolStore } from '../../store/school/useSchoolStore'
import { CustomDatePicker } from '../common/Input'
import { BaseDivider, BaseModal, BaseModalHeader } from '../common/Modal'
import { ModalText } from '../common/Text'
import { SelectUpdateTanks } from './SelectUpdateTanks'

export interface SelectTanksUpdateProps {
  isOpen: boolean
  onOpenChange: () => void
  onOpen: () => void
}

export const SelectTanksUpdate: FC<SelectTanksUpdateProps> = ({ isOpen, onOpenChange, onOpen }) => {
  const storedSchoolList = useSchoolStore((state) => state.schools)
  const {
    updateDate,
    setSchoolValues,
    selectedTankIds,
    setDateBorderColor,
    setSelectedTanksBorderColor,
    setUpdateDate,
    dateBorderColor,
  } = useHomeUpdateStore()

  const checkTanksBeforeContinue = (onClose: () => void, onOpen: () => void) => {
    setDateBorderColor()
    setSelectedTanksBorderColor()

    if (updateDate !== null && selectedTankIds.length !== 0) {
      getUpdate(selectedTankIds, updateDate, storedSchoolList, setSchoolValues, onClose, onOpen)
    }
  }

  return (
    <BaseModal isOpen={isOpen} onOpenChange={onOpenChange} size={'3xl'} isDismissable={true}>
      <ModalContent className="overflow-x-hidden">
        {(onClose) => (
          <>
            <BaseModalHeader title="Update" description={ModalText('Update')} />
            <ModalBody className="gap-1 min-h-[8rem] pl-6 sm:pl-10 pr-6 sm:pr-10 overflow-x-hidden overflow-y-auto">
              <BaseDivider />
              <SelectUpdateTanks />
              <CustomDatePicker
                label="Date to Update"
                value={updateDate}
                setValue={setUpdateDate}
                dateBorderColor={dateBorderColor}
                warnText="Please enter a Date to Update."
              />
            </ModalBody>
            <ModalFooter className="pb-6 sm:pb-8 pl-6 sm:pl-10 pr-6 sm:pr-10">
              <Button
                className="font-bold text-white w-[6rem] mr-0 bg-tdplplum"
                onPress={() => {
                  checkTanksBeforeContinue(onClose, onOpen)
                }}
              >
                Continue
              </Button>
            </ModalFooter>
          </>
        )}
      </ModalContent>
    </BaseModal>
  )
}
